module.exports = __webpack_public_path__ + "img/title-sygl.16753d28.png";